import React from "react";

import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ArrowUpward from "@material-ui/icons/ArrowUpward";

import { Column, OrderButton } from "./styles";

interface OrderButtonsProps {
    onUp: () => void;
    onDown: () => void;
    disableUp?: boolean;
    disableDown?: boolean;
}

export const OrderButtons = ({ onUp, onDown, disableUp, disableDown }: OrderButtonsProps) => (
    <Column>
        <OrderButton type="button" onClick={onUp} disabled={disableUp}>
            <ArrowUpward fontSize="small" />
        </OrderButton>
        <OrderButton type="button" onClick={onDown} disabled={disableDown}>
            <ArrowDownward fontSize="small" />
        </OrderButton>
    </Column>
);
